import './PerformanceRecordDetailsScreen.scss';
import CardComponent from "../../../shared/components/card/CardComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import {ImageConfig} from "../../../constants";
import moment from "moment-timezone";
import {CommonService} from "../../../shared/services";
import {useState} from "react";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import AllBundlePacksComponent from "../all-bundle-packs/AllBundlePacksComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import PerformanceRecordSharedDocumentComponent
    from "../performance-record-shared-documents/PerformanceRecordSharedDocumentComponent";

interface PerformanceRecordDetailsScreenProps {
    performanceRecordData: any;
};

const PerformanceRecordDetailsScreen = (props: PerformanceRecordDetailsScreenProps) => {
    const {performanceRecordData} = props;
    const [isAllBundlePackModalOpen, setIsAllBundlePackModalOpen] = useState(false);

    return (
        <div className="performance-record-details-screen">
            <CardComponent className={'mrg-top-30'}>
                <div className={'performance-record-card-header'}>
                    <div className={'case-details-heading'}>Case Details</div>
                    <ChipComponent label={performanceRecordData?.status}
                                   className={performanceRecordData?.status === 'open' ? 'open' : 'closed'}/>
                </div>
                <div className={'performance-record-card-body'}>
                    <div className={'medical-record-card-body-upper-item'}>
                        <div className={'container'}>
                            <div className={'icon-wrapper'}>
                                <ImageConfig.Calendar3Icon height={30} width={30}/>
                            </div>
                            <div className={'details-wrapper'}>
                                <div>Program Start Date</div>
                                <div
                                    className={'mrg-top-5'}>
                                    <b>{performanceRecordData?.program_start_date ? moment(performanceRecordData?.program_start_date).format('DD-MMM-YYYY') : 'N/A'}</b>
                                </div>

                            </div>
                        </div>

                        <div className={'container  justify-content-center'}>
                            <div className={'icon-wrapper'}>
                                <ImageConfig.HashIcon height={30} width={30}/>
                            </div>
                            <div className={'details-wrapper'}>
                                <div>Sessions Completed</div>
                                <div
                                    className={'mrg-top-5'}>
                                    <b>{performanceRecordData?.sessions_completed > 1 ? performanceRecordData?.sessions_completed + ' sessions' : performanceRecordData?.sessions_completed + ' session'}</b>
                                </div>

                            </div>
                        </div>
                        <div className={'container last-container  justify-content-center '}>
                            <div className={'icon-wrapper'}>
                                <ImageConfig.HashIcon height={30} width={30}/>
                            </div>
                            <div className={'details-wrapper'}>
                                <div>Active Bundle Packs</div>
                                <div className={'mrg-top-5'}>
                                    <b>{performanceRecordData?.total_active_bundle_pack > 1 ? performanceRecordData?.total_active_bundle_pack + ' bundle packs' : performanceRecordData?.total_active_bundle_pack + ' bundle pack'}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'description-wrapper'}>
                        <div className={'icon-wrapper'}>
                            <ImageConfig.DocumentIcon height={30} width={30}/>
                        </div>
                        <div>
                            <div className={'description-heading'}>Description</div>
                            <div className={'description-body'}>
                                <b> {performanceRecordData?.category_details?.name} - {performanceRecordData?.service_details?.name}</b>
                            </div>
                        </div>
                    </div>
                    <div className={'description-wrapper'}>
                        <div className={'icon-wrapper'}>
                            <ImageConfig.DocumentClipIcon height={30} width={30}/>
                        </div>
                        <div>
                            <div className={'description-heading'}>Case Name</div>
                            <div className={'description-body'}>
                                <b> {CommonService.getDateFromTimezone(performanceRecordData?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - {performanceRecordData?.program_focus}</b>
                            </div>
                        </div>
                    </div>
                    <div className={'existing-bundle-packs-wrapper'}>
                        <div className={'existing-bundle-packs-heading'}>
                            Existing Bundle Packs:
                        </div>
                        {performanceRecordData?.purchased_bundle_pack?.length > 3 &&
                            <div onClick={() => setIsAllBundlePackModalOpen(true)} className={'view-all-btn'}>
                                View All
                            </div>}
                    </div>
                    <div className={'purchased-bundle-packs-wrapper pdd-bottom-20'}>
                        {performanceRecordData?.purchased_bundle_pack?.slice(0, 3).map((bundlePack: any, index: number) => (
                            <div key={index} className={`purchased-bundle-pack-item ts-col-lg-4 ts-col-md-4 ts-col-sm-6 ts-col-xs-12 ${index === performanceRecordData?.purchased_bundle_pack?.slice(0, 3).length - 1 ? 'no-border' : ''}`}>
                                <div className={'purchased-bundle-pack-item-heading'}>
                                    {bundlePack.consultation_details?.title} - {bundlePack.consultation_details?.consultation_details[0]?.duration + ' minutes'}
                                </div>
                                <div className={'purchased-bundle-pack-item-body'}>
                                    Total Sessions: {bundlePack?.total_sessions}
                                </div>
                                <div className={'purchased-bundle-pack-item-body'}>
                                    Remaining Sessions: {bundlePack?.total_sessions - bundlePack?.booked_sessions}
                                </div>
                                <div className={'purchased-bundle-pack-item-body'}>
                                    Expiry
                                    Date: {CommonService.getDateFromTimezone(bundlePack?.expiry_date, moment.tz.guess(), 'DD-MMM-YYYY')}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </CardComponent>
            <PerformanceRecordSharedDocumentComponent performanceRecordId={performanceRecordData?._id}/>
            <ModalComponent isOpen={isAllBundlePackModalOpen}
                            onClose={() => setIsAllBundlePackModalOpen(false)}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-20'} onClick={() =>
                                setIsAllBundlePackModalOpen(false)
                            }>
                                Close
                            </ButtonComponent>}
            >
                <AllBundlePacksComponent allBundlePacks={performanceRecordData?.purchased_bundle_pack}/>
            </ModalComponent>
        </div>
    )
        ;
}
export default PerformanceRecordDetailsScreen;
